import { pdf } from "@react-pdf/renderer";
import TicketingSalesReportPDF from "../components/pdf/TicketingSalesReportPDF";

const safeFilename = (value) =>
  String(value || "vente")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();

export default async function downloadTicketingSalesReport({ report, labels }) {
  const blob = await pdf(<TicketingSalesReportPDF report={report} labels={labels} />).toBlob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `rapport-vente-${safeFilename(report.eventName)}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
